import React, {Component, Fragment} from 'react';
import lightBulg from "./icons/24_light_bulb.svg";
import {Tooltip} from "../tooltip/Tooltip";
import Onboarding from "../popup/OnboardingPopop.component";
import _ from "lodash";
import {Button, ButtonType} from "components/common/Button.component.tsx";
import {MODAL_ACTIONS} from "utils/constants";
import {launchDarkly} from "utils/launchDarkly";
import {useModalContext} from "components/modals/ModalContext";

const showOnboardingEvent = "showOnboardingEvent";
const closeOnboardingEvent = "closeOnboardingEvent"
const oldOnboardingPopup = localStorage.getItem('onboarding/popup/hideDetachOnboarding');

class OnboardingTaskDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showOnboardingPopup: false,
            showOnboardingTooltip: false,
            showNotification: false
        };
        this.onboardingIcon = React.createRef();
        this.showOnboarding = this.showOnboarding.bind(this);
        this.closeOnboarding = this.closeOnboarding.bind(this);
        this.dispatchOnboarding = this.dispatchOnboarding.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.dismiss = this.dismiss.bind(this);
    }

    componentDidMount() {
        //clear old cookies
        if (oldOnboardingPopup)
            localStorage.removeItem('onboarding/popup/hideDetachOnboarding');
       // this.showOnboarding();
        document.addEventListener('mousedown', this.handleClickOutside);
        // open on mount if the flag is already on and onboarding should show
        this.openOnboardingModalIfNeeded();
    }

    componentDidUpdate(prevProps, prevState) {
        // react to onboarding becoming visible (false -> true)
        if (!prevState.showOnboardingPopup && this.state.showOnboardingPopup) {
            this.openOnboardingModalIfNeeded();
        }
    }

    openOnboardingModalIfNeeded = () => {
        if (
            this.props.useNewModals &&
            this.props.toggleModal &&
            this.state.showOnboardingPopup
        ) {
            this.props.toggleModal(MODAL_ACTIONS.ONBOARDING, {
                userData: this.props.userData,
                closeCallback: this.closeOnboarding,
            });
            this.setState({showOnboardingTooltip: false});
        }
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    showOnboarding() {
        const onboardingPopup = localStorage.getItem('onboarding/popup/hideAiAssistantOnboarding');
        if (onboardingPopup === 'true') {
            return;
        }
        this.dispatchOnboarding();
    }

    dispatchOnboarding() {
        this.setState({
            showOnboardingTooltip: true
        }, () => {
            this.onboardingIcon.current?.dispatchEvent(new Event(showOnboardingEvent));
        })
    }

    closeOnboarding() {
        this.setState({showOnboardingPopup: false, showOnboardingTooltip: false, showNotification: false});
        this.onboardingIcon.current?.dispatchEvent(new Event(closeOnboardingEvent));
        localStorage.setItem('onboarding/popup/hideAiAssistantOnboarding', 'true');
    }

    handleClickOutside = (event) => {
        if (
            this.state.showOnboardingTooltip &&
            this.onboardingIcon.current &&
            !this.onboardingIcon.current.contains(event.target)
        ) {
            this.closeOnboarding();
        }
    };

    dismiss() {
        this.setState({
            showNotification: false,
            showOnboardingTooltip: false
        })
        this.onboardingIcon.current?.dispatchEvent(new Event(closeOnboardingEvent));
    }


    render() {

        const content = _.times(1, (index) => {
            let time = index + 1;
            return <div key={time}>{this.props.translate("menu.onboarding.content" + time)}</div>
        });

        return (
            <Fragment>
                <li className={"icon " + (this.state.showNotification ? "attention" : "")}
                    data-for={"onboarding-tooltip"} data-tip ref={this.onboardingIcon}>
                    <a className="button-help" href="#"
                       onClick={(event) => {
                           event.preventDefault();
                           (this.state.showOnboardingTooltip ? this.closeOnboarding : this.dispatchOnboarding)();
                       }}>
                        <img alt={"light bulb"} src={lightBulg} className={"appicon vismaicon-dynamic border-0"}/>
                    </a>
                </li>

                {this.state.showOnboardingTooltip &&
                    <Tooltip
                        place="bottom"
                        id={"onboarding-tooltip"}
                        event={showOnboardingEvent}
                        eventOff={closeOnboardingEvent}
                        content={() => {
                            return <div className={"d-flex flex-column"}>

                                    <div className={"ga-tooltip__title"}>{this.props.translate("menu.onboarding.title")}</div>
                                    <div>{content}</div>

                                    <div className={"mt-24 d-flex justify-content-between"}>
                                        <Button type={ButtonType.SECONDARY}
                                                tabIndex={0}
                                                onClick={this.closeOnboarding}
                                                text={this.props.translate("menu.onboarding.ok")}
                                        />
                                    </div>
                            </div>
                        }}
                    />
                }

                {this.state.showOnboardingPopup && !this.props.useNewModals &&
                    <Onboarding loggedInData={this.props.loggedInData}
                                userData={this.props.userData}
                                closeCallback={this.closeOnboarding}/>
                }
            </Fragment>
        )
    }
}

const OnboardingTaskDetailsWithModal = (props) => {
    const useNewModals = launchDarkly.companyClient?.variation("use-new-modals", false);
    const modalContext = useModalContext();
    const toggleModal = modalContext?.toggleModal;
    return <OnboardingTaskDetails {...props} useNewModals={useNewModals} toggleModal={toggleModal}/>;
};

export default OnboardingTaskDetailsWithModal;
